export { default } from './QuotationUGCEditor';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/UGCEditors/QuotationUGCEditor/index.js